import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_spaces_user_transition = _resolveComponent("spaces-user-transition")!
  const _component_app_skeleton_contact = _resolveComponent("app-skeleton-contact")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_openBlock(), _createBlock(_component_app_item_wrapper, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
    ]),
    control: _withCtx(() => []),
    main: _withCtx(() => [
      (!_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_spaces_user_transition, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.my, (contact) => {
                return (_openBlock(), _createBlock(_component_spaces_user, {
                  key: contact.user.accountId,
                  user: contact.user,
                  userType: _ctx.NETWORK_CONTACT_TYPES.MY,
                  publicCasesAmount: contact.user.publicCasesAmount
                }, null, 8, ["user", "userType", "publicCasesAmount"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_app_skeleton_contact),
            _createVNode(_component_app_skeleton_contact)
          ], 64))
    ]),
    _: 1
  }))
}